import { IUser } from 'api'
import { message } from 'antd'
import { graphqlOperation, API } from 'aws-amplify'
import i18next from 'i18next'
import { IAppSyncSubscriptionResponse, ISubscribeAppSyncEvent } from './models'

const RECONNECT_AFTER_MS = 2000

export const getAppSyncEventSubscription = (userId: IUser['id']) =>
	`subscription {
  getUpdatedMainEvent(externalUserId: "${userId}") {
    eventType
    payload {
      id
			transfersCreated
			taxYear
    }
  }
}`

export const subscribeToAppsyncEvent = ({ userId, onReceive, reconnect }: ISubscribeAppSyncEvent) => {
	return API.graphql<IAppSyncSubscriptionResponse>(graphqlOperation(getAppSyncEventSubscription(userId))).subscribe({
		next: onReceive,
		error: errorObject => {
			const { error, errors } = errorObject
			// reconnect
			if (error && error.errorMessage && error.errorMessage.indexOf('Socket closed') !== -1) {
				// to prevent Maximum Call Stack exceeded loop
				setTimeout(() => reconnect, RECONNECT_AFTER_MS)
				return
			}
			// This error handler will be available globaly on any page
			// for the entire Websocket connection for the App
			if (errors && errors[0] && errors[0].message === 'Network Error') {
				const errorMessage = i18next.t('errors.CONNECTION_LOST')
				message.error(errorMessage)
			}
		},
	})
}
